import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import AdvancedMediaViewerPinchToZoom from '../AdvancedMediaViewerPinchToZoom/AdvancedMediaViewerPinchToZoom';
import './AdvancedMediaViewerImage.scss';
import AdvancedMediaViewerOverlay from '../AdvancedMediaViewerOverlay/AdvancedMediaViewerOverlay';
import useUserInactivity from '../../hooks/useUserInactivity';
import { isRatioSimilar, getScaleRatio } from '../../hooks/useAspectRatio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';



const AdvancedMediaViewerImage = ({media, isActive, coverMode, setToggleSlider, toggleSlider, handleClose}) => {
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [scaleRatio, setScaleRatio] = useState(null);
    const containerRef = useRef(null);
    const src = `${media.previewUrl}?height=1600`;
    const { isUserInactive, handleInteractionStart, handleInteractionEnd } = useUserInactivity(isActive && !isLoading);

    const imageOnload = (event) => {
        const image = event.target;
        const width = image.naturalWidth;
        const height = image.naturalHeight;
        if (containerRef.current && coverMode) {
            const { clientWidth, clientHeight } = containerRef.current;
            if (clientWidth && clientHeight) {
                const containerRatio = clientWidth / clientHeight;
                const imageRatio = (width / height);
                const scaleRatio = getScaleRatio(imageRatio, containerRatio);
                const fullScreen = isRatioSimilar(imageRatio, containerRatio, 0.35);
                if (fullScreen) {
                    setScaleRatio(scaleRatio);
                }
            }
        }
        setIsLoading(false);
    };

    return (
        <div  
            ref={containerRef}
            className={classNames("amv-media-image")}
            onTouchStart={handleInteractionStart}
            onTouchEnd={handleInteractionEnd}
            onMouseMove={isUserInactive ? handleInteractionStart : handleInteractionEnd}
            onTouchCancel={handleInteractionEnd}
            >
            <AdvancedMediaViewerOverlay 
                media={media}
                isUserInactive={isUserInactive}
                sliderEnable={toggleSlider}
                setSliderEnable={setToggleSlider}
                handleCloseAMV={handleClose}
            />
            {(isLoading && !error) && (
                <div className="amv-media-image-loading">
                   <FontAwesomeIcon className="amv-media-image-loading-icon" icon={faSpinnerThird} spin />
                </div>
            )}
            {(error) && (
                <div className="amv-media-image-error">
                    Problème au chargement de la photo
                </div>
            )}
            {!error && (
                <AdvancedMediaViewerPinchToZoom scaleRatio={scaleRatio} onZoom={(isZooming)=>setToggleSlider(!isZooming)}>
                    <img
                        onLoad={imageOnload}
                        onError={()=>setError(true)}
                        src={src}
                        alt={media?.title}
                        onContextMenu={(e)=> e.preventDefault()}
                        onDragStart={(e)=> e.preventDefault()}
                    />
                </AdvancedMediaViewerPinchToZoom>
            )}
        </div>
    )
}

export default AdvancedMediaViewerImage;